// import { Order } from '../models';
// export function diffOrders(originalOrders: Order[], allOrders: Order[]) {
//   var diffOrders: Order[] = [];
//
//   allOrders.forEach((allOrder) => {
//     if (allOrder.id == null) {
//       // Novy order
//       diffOrders.push(allOrder);
//     } else {
//       // patch -  kontrola itemu
//     }
//   });
//   return diffOrders;
// }

export default {};
